import React, { createContext, useContext, useEffect, useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import emitter from "../Utils/eventEmitter";

const SnackbarContext = createContext();

export const useSnackbar = () => {
  return useContext(SnackbarContext);
};

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    message: "",
    open: false,
    severity: "info", // Can be 'success', 'info', 'warning', 'error'
  });

  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ message, open: true, severity });
  };

  const handleClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
 // Listen for global Snackbar events
 useEffect(() => {
    emitter.on('show-snackbar', (message, severity) => {
      showSnackbar(message, severity);
    });

    return () => {
      emitter.off('show-snackbar'); // Cleanup listener
    };
     //eslint-disable-next-line
  }, []);
  return (
    <SnackbarContext.Provider value={showSnackbar}>
      {children}
      <Snackbar
        place
        open={snackbar.open}
        autoHideDuration={1000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
          className="mt-20"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};
